angular.module('lsnBase.deprecated.models')
  .factory('VehicleModelConstants', ['LsnVehicleModelConstants', function(LsnVehicleModelConstants) {
    return LsnVehicleModelConstants;
  }])
  .factory('VehicleModel', ['LsnVehicleModelV1',
    function(LsnVehicleModelV1) {
      return LsnVehicleModelV1;
    }
  ]);